export * from "./tabbed-card.component";
